import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { DepartmentListResource } from 'app/models/DepartmentListResource';
import { DepartmentResource } from 'app/models/DepartmentResource';
import { UtilsService } from 'app/services/utils.service';
import { BehaviorSubject, combineLatest, EMPTY, forkJoin, Observable, Subject } from 'rxjs';
import { catchError, map, startWith, tap } from 'rxjs/operators';

@Component({
  selector: 'vbn-departments-list',
  templateUrl: './departments-list.component.html',
  styleUrls: ['./departments-list.component.scss']
})
export class DepartmentsListComponent implements OnInit {

  errorMessage: any;
  departmentList: DepartmentListResource;
  deleteDepartmentId: number;
  showDeletePop = false;


  selectedClient = (atob(localStorage.getItem("_sc")) === atob(null)) ? null : atob(localStorage.getItem("_sc"));
  clientEmail = (this.selectedClient == null) ? "" : "?clientEmail=" + this.selectedClient
  userEmail: string;

  isOnResponsive: boolean = false;


  constructor(private service: UtilsService,
    private router: Router,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private utilsService: UtilsService) {
    this.departmentList = new DepartmentListResource();
    this.departmentList.departmentList = [];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1300) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }

  ngOnInit() {
    this.getDepartmentList();
    if (innerWidth <= 1300) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
    this.userEmail = this.utilsService.currentUserEmail;
  }

  getDepartmentList() {
    this.service.get(`/admin/department/getAll${this.clientEmail}`)
      .subscribe(
        response => { this.departmentList = response },
        err => this.errorMessage = err
      )
  }

  edit(id) {
    this.router.navigate(['/add-edit-appointment-department/' + btoa('{ "departmentId" : "' + id + '"}')])
  }

  showDeletePopUp(id: number) {
    this.deleteDepartmentId = id;
    this.showDeletePop = true;
  }

  hideDeletePopUp(id: number) {
    this.showDeletePop = false;
  }

  deleteDepartment() {
    this.service.get(`/admin/department/removeDepartmentById/${this.deleteDepartmentId}`)
      .subscribe(
        (response: DepartmentResource) => {
          if (response.errorCode === 10902) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`You can not delete departments with appointments on it`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            if (response.errorCode === 10901) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Department not found`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            } else {
              forkJoin(
                [this.translate.get('Success'),
                this.translate.get(`Department was deleted`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'success')
              })
              this.getDepartmentList();
            }
          }
          this.showDeletePop = false;
        }
      )
  }

  showResponsiveDetails(id) {
    const width = window.innerWidth;
    if (width <= 1300) {
      for (let i = 0; i < this.departmentList.departmentList.length; i++) {
        if (this.departmentList.departmentList[i].id === id) {
          this.departmentList.departmentList[i].showDetailsOnResponsive = !this.departmentList.departmentList[i].showDetailsOnResponsive;
        }
        else {
          this.departmentList.departmentList[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }
}
